import { InputType } from "../types";

export const DisplayNamesOfInput: InputType = [{ value: 'US', type: 'string' }];
